// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"532":"7e5c8ffc26ba6d8478b2","589":"3ae648335ab5fcdc83d8","678":"3733a85ae1990b6fca45","883":"bceeeb7c4186f890964a"}[chunkId] + ".js";
};